module.exports = __webpack_public_path__ + "static/material-icons-regular-570eb83859dc23dd0eec423a49e147fe.woff2";